/**
 * The Azure cloud a jumphost is provisioned in.
 */
export enum AzureCloud {
  AzureGlobal = 'AzureGlobal',
  AzureChina = 'AzureChina',
}

/**
 * Data required to provision a jumphost
 */
export interface JumphostProvisionData {
  /**
   * The hub to provision the jumphost in
   */
  hub: string;
  /**
   * The cluster to provision the jumphost in
   */
  cluster: string;
  /**
   * The product stage to provision the jumphost for
   */
  productStage: string;
  /**
   * The ssh key to use for the jumphost
   */
  sshKey: string;
  /**
   * The vm size to use for the jumphost
   */
  vmSize: string;
  /**
   * The cloud init script to use for the jumphost
   */
  cloudInit: string;
}

export interface ProductStage {
  name: string;
  hub: string;
  cluster: string;
}

export interface SSHKeyPair {
  privateKey: string;
  publicKey: string;
}
